import { CellProps } from "./types"

export const Cell = ({
  value
}: CellProps) => {
  return (
    <td>{value}</td>
  )
}